// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "all-260209-0/static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"1001946c","777":"ed653df3"}[chunkId] + ".chunk.js";
};